import React from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { bool, string } from 'prop-types';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import css from './NoResultsBlock.css';
import { Button } from '../../components';
import classNames from 'classnames';
import { useIsMobile } from '../../hooks/useIsMobile';
import { redirectToURLWithModalState } from '../Topbar/Topbar.helpers';
import { IconSearchM } from '../../icons';

const ActionButton = ({ history, renderActionButton, buttonId, pageName }) => {
    if (typeof renderActionButton === 'function') {
        return renderActionButton({
            containerClassName: css.buttonContainer,
        });
    }

    const navigateToPage = pageName => {
        history.push(
            createResourceLocatorString(
                pageName ? pageName : 'ManageListingsPage',
                routeConfiguration()
            )
        );
    };
    const buttonLinkMaybe = buttonId && pageName;

    if (buttonLinkMaybe) {
        return (
            <div className={css.buttonContainer}>
                <Button type="button" onClick={() => navigateToPage(pageName)}>
                    {buttonId}
                </Button>
            </div>
        );
    }

    return null;
};

const NoResultsBlock = ({
    headerId,
    parapraphId,
    buttonId,
    isSearchForm,
    history,
    location,
    pageName,
    rootClass,
    searchFormPlaceholder = 'Suche in deiner Nähe',
    children,
    renderActionButton,
}) => {
    const [isMobile] = useIsMobile(1024);

    const rootClassName = rootClass ? classNames(css.noResults, rootClass) : css.noResults;

    return (
        <div className={rootClassName}>
            <h1>{headerId}</h1>
            <p>{parapraphId}</p>
            {isSearchForm ? (
                <div className={css.dumbInputRoot}>
                    <input
                        type="text"
                        className={css.dumbInput}
                        placeholder={searchFormPlaceholder}
                        onFocus={() =>
                            redirectToURLWithModalState(
                                { location, history },
                                isMobile ? 'mobilesearch' : 'desktopsearch'
                            )
                        }
                    />
                    <div className={css.dumbFieldIconHolder}>
                        <IconSearchM />
                    </div>
                </div>
            ) : (
                <ActionButton
                    history={history}
                    buttonId={buttonId}
                    pageName={pageName}
                    renderActionButton={renderActionButton}
                />
            )}
            {children}
        </div>
    );
};

NoResultsBlock.propTypes = {
    headerId: string.isRequired,
    parapraphId: string.isRequired,
    buttonId: string,
    className: string,
    isSearchForm: bool,
    pageName: string,
    rootClass: string,
};

export default compose(withRouter)(NoResultsBlock);
